/** Placeholder row required when no credit note is claimed (SQL TVP cannot be empty). */
const EMPTY_DT_REFUNDDET_ROW = {
  ODRETURNCODE: "0",
  RETURNNO: "0",
  RETURNTYPECODE: "0",
  REFUNDAMOUNT: 0,
  ISREFUND: "",
  REFUNDSTS: "",
};

/**
 * Build dtrefunddet for ORDER_API_07. Backend requires at least one row in the structured type.
 */
export function buildDtRefundDetParam(claimedCreditNote, refundAmount = 0) {
  if (!claimedCreditNote) {
    return [EMPTY_DT_REFUNDDET_ROW];
  }

  return [
    {
      ODRETURNCODE: String(claimedCreditNote?.odreturncode || ""),
      RETURNNO: String(claimedCreditNote?.returnno || ""),
      RETURNTYPECODE: String(claimedCreditNote?.returnTypeCode || ""),
      REFUNDAMOUNT: Number(refundAmount) || 0,
      ISREFUND: "N",
      REFUNDSTS: "A",
    },
  ];
}
